/** @format */

import {IconFillProps} from './model';

const IconFunnel = ({fill = '#59C591'}: IconFillProps) => (
  <svg width='49' height='10' viewBox='0 0 49 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect y='2' width='49' height='1.6' rx='0.8' fill={fill} />
    <rect x='16.3333' y='5.19995' width='16.3333' height='1.6' rx='0.8' fill={fill} />
    <rect x='19.6001' y='8.3999' width='9.8' height='1.6' rx='0.8' fill={fill} />
  </svg>
);

export default IconFunnel;
